import actionTypes from "../actionTypes";
export default {
  dynamicUpdate: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.GLOBAL_DYNAMIC_UPDATE_CHAT,
      payload: data,
    });
  },
  setChatAgentAssist: (data, identifier) => (dispatch) => {
    console.log("data[action]", data);
    dispatch({
      type: actionTypes.CHAT_AGENT_ASSIST,
      payload: { data, identifier },
    });
  },
  clearChatAgentAssist: (idf) => (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_CHAT_AGENT_ASSIST,
      payload: { idf },
    });
  },
  updateTranslate: (selectedChat, id, translatedText) => (dispatch) => {
    console.log("id, translateText", selectedChat, id, translatedText);
    dispatch({
      type: actionTypes.UPDATE_TRANSLATE,
      payload: { selectedChat, id, translateText: translatedText },
    });
  },

  setLoadingAgentAssist: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.LOADING_AGENT_ASSIST,
      payload: data,
    });
  },

  setDisposeScreen: (data) => (dispatch) => {
    console.log("data[action]", data);
    dispatch({
      type: actionTypes.SET_DISPOSE_SCREEN,
      payload: data,
    });
  },

  setActiveTab: (data) => (dispatch) => {
    console.log("data[action]", data);
    dispatch({
      type: actionTypes.SET_ACTIVE_TAB,
      payload: data,
    });
  },

  setActiveTabRight: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.SET_ACTIVE_TAB_RIGHT,
      payload: data,
    });
  },

  setListRedux: (data) => (dispatch) => {
    console.log("data[action]", data);
    dispatch({
      type: actionTypes.SET_LIST_REDUX,
      payload: data,
    });
  },

  setCurrentLevelTagsRedux: (data) => (dispatch) => {
    console.log("data[action]", data);
    dispatch({
      type: actionTypes.SET_CURRENT_LEVEL_TAGS,
      payload: data,
    });
  },
};



// WEBPACK FOOTER //
// src/store/action/chat.action.js